<!-- <h2 mat-dialog-title>Logout Session</h2>

<mat-dialog-content>

<p> We haven't received anything from your side since a long time, Do you want to continue?  </p>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" (click)="close('Y')">Yes</button>
    <button class="mat-raised-button" (click)="close('N')">No</button>
</mat-dialog-actions> -->



<div class="confirm">
    <h1 matDialogTitle>Logout Session</h1>
    <p class="timer" >{{display}}</p>
    <p>Your session is about to expire.</p>
<p>If you would like to keep your session alive press "OK" to continue</p>
<div mat-dialog-actions class="pt-24 action">
    <button mat-flat-button color="basic" (click)="ClickNo('N')">Logout Now</button>
    <button  mat-flat-button color="primary" (click)="ClickYes('Y')">Ok</button>
</div>

</div>